import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BreadCrumb from "src/Components/GlobalComponents/BreadCrumb";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import SearchFilterInput from "src/Components/GlobalComponents/SearchFilterInput";
import SelectDropdown from "src/Components/GlobalComponents/SelectDropdown";
import TableWrapper from "src/Components/GlobalComponents/TableWrapper";
import SimpleInput from "src/Components/SimpleInput";
import moment from "moment";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IPaginated } from "src/types/paginated";
import httpRequest from "src/helpers/httpRequest";
import qs from "qs";
import { toast } from "react-toastify";
import { truncateString } from "src/helpers/helperFunctions";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { canWrite } from "src/helpers/helperFunctions";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";
import { CURRENCY } from "src/lib/constans";
type statusType = "pending" | "cancelled" | "completed" | "deleted";
const statusColor = {
  yellow: "#FFF4B3",
  green: "#B3E3B2",
  red: "#FEC0C2",
};
const statusList: { label: string; value: statusType }[] = [
  { label: "Pending", value: "pending" },
  { label: "Completed", value: "completed" },
  { label: "Cancelled", value: "cancelled" },
];

interface IObj {
  _id: string;
  patientName: string;
  totalAmount: number;
  appointmentDate: string;
  status: statusType;
  serialOrderId: string;
  timeslot: string;
  createdAt: string;
  serviceName: string;
  [key: string]: any;
}
interface IFilterStates {
  status: "" | statusType;
  search: string;
  startDate: string;
  endDate: string;
}
interface IQueryParams {
  status: "" | statusType;
  search: string;
  startDate: string;
  endDate: string;
  page: number;
  limit: number;
}
interface IResponse {
  documents: IObj[];
  paginated: IPaginated;
}

const HomecareAppointments: React.FC = () => {
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const hasWriteAccess = canWrite(userDetails, "homeServiceAppointment", false);

  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [allAppointments, setAllAppointments] = useState<IObj[]>([]);
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  }); // Handles pagination
  const [filterStates, setFilterStates] = useState<IFilterStates>({
    status: "", 
    search: "",
    startDate: "",
    endDate: "",
  });
  const [queryParams, setQueryParams] = useState<IQueryParams>({
    status: "",
    search: "",
    startDate: "",
    endDate: "",
    page: 1,
    limit: 10,
  });

  const handleChangeFilterStates = (key: keyof IFilterStates, val: string) => {
    setFilterStates((prev) => ({ ...prev, [key]: val }));
  };
  const emptyAllField = (): boolean => {
    const { status, startDate, endDate, search } = filterStates;
    if (!status && !startDate && !endDate && !search) {
      return true;
    }
    return false;
  };
  const applyFilter = () => {
    const { status, startDate, endDate, search } = filterStates;
    setQueryParams((prev) => ({
      ...prev,
      status,
      startDate,
      endDate,
      search,
      page: 1,
    }));
  };
  const resetFilter = () => {
    setFilterStates({
      status: "",
      search: "",
      startDate: "",
      endDate: "",
    });
    setQueryParams({
      status: "",
      search: "",
      startDate: "",
      endDate: "",
      page: 1,
      limit: 10,
    });
  };

  // Handles page change in pagination
  const handlePageChange = (e: number) => {
    setQueryParams((prev) => ({
      ...prev,
      page: e,
    }));
  };

  const fetch = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IResponse>({
      path: `/home-care-order/admin-all-orders?${qs.stringify(queryParams)}`,
    });
    if (res) {
      const { documents = [], paginated = { currentPage: 1, totalPages: 1 } } =
        res;
      setAllAppointments(documents);
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };
  useEffect(() => {
    fetch();
  }, [queryParams]);

  const handleDateChange = (key: keyof IFilterStates, val: string) => {
    const currentStartDate = filterStates.startDate
      ? new Date(filterStates.startDate)
      : null;
    const currentEndDate = filterStates.endDate
      ? new Date(filterStates.endDate)
      : null;
    const newDate = val ? new Date(val) : null;

    if (newDate) {
      if (key === "startDate" && currentEndDate && newDate > currentEndDate) {
        toast("Start Date cannot be later than End Date.", { type: "error" });
        return; // Stop further execution
      }
      if (key === "endDate" && currentStartDate && newDate < currentStartDate) {
        toast("End Date cannot be earlier than Start Date.", { type: "error" });
        return; // Stop further execution
      }
    }

    handleChangeFilterStates(key, val); // Only call if validation passes
  };

  return (
    <>
      <BreadCrumb
        current="At-home Appointment"
        previous="dashboard"
        navigateUrl="/admin"
      />
      <div className="table-container">
        {/* <div className="grid grid-cols-1 select-filter-height md:grid-cols-3 lg:grid-cols-5 gap-3 items-center">
          <div className="select-option-drop-down">
            <CustomWebsiteDropdown
              options={statusList}
              setData={(e) =>
                handleChangeFilterStates("status", e[0] ? e[0].value : "")
              }
              data={statusList.filter((v) => v.value === filterStates.status)}
              dropdownMainId="status-dropdown"
              isMulti={false}
              placeholder="Filter by Status"
              dropdownInnerStyle={{
                padding: "0px 0.5rem",
                height: "40px",
                display: "flex",
                alignItems: "center",
              }}
              extraClass="!mt-0 !mb-0"
            />
          </div>
          <div>
            <SimpleInput
              value={filterStates?.startDate}
              onChange={(val) => handleDateChange("startDate", val)}
              type="date"
              placeholder="Start Date"
              extraStyle={{ borderColor: "#00a297", margin: 0, height: 40 }}
              id="start-date"
            />
          </div>
          <div>
            <SimpleInput
              value={filterStates?.endDate}
              onChange={(val) => handleDateChange("endDate", val)}
              type="date"
              placeholder="End Date"
              extraStyle={{ borderColor: "#00a297", margin: 0, height: 40 }}
              id="end-date"
            />
          </div>
          <div>
            <SearchFilterInput
              key={queryParams?.search}
              containerExtraStyle={{ display: "block" }}
              inputExtraStyle={{
                width: "100%",
                marginBottom: 0,
                borderColor: "#00a297",
                height: 40,
              }}
              searchVal={filterStates?.search}
              debounceTime={0}
              onChangeText={(val) => handleChangeFilterStates("search", val)}
            />
          </div>
          <div className="flex items-center gap-3 justify-end">
            <PrimaryBtn
              disabled={
                !queryParams.status &&
                !queryParams.startDate &&
                !queryParams.endDate &&
                !queryParams.search
              }
              id="reset-btn"
              ButtonText="Reset"
              onPress={resetFilter}
              btnExtraStyle={{
                borderRadius: "1.5rem",
                backgroundColor: "#004540",
                padding: "6px 30px",
              }}
            />
            <PrimaryBtn
              id="apply-btn"
              ButtonText="Apply"
              // disabled={emptyAllField()}
              onPress={applyFilter}
              btnExtraStyle={{
                borderRadius: "1.5rem",
                backgroundColor: "#004540",
                padding: "6px 30px",
              }}
            />
          </div>
        </div> */}
        <div className="flex items-center gap-3 justify-between">
          <div className="flex items-center gap-[0.2rem] lg:gap-[0.3vw]">
            <CustomWebsiteDropdown
              options={statusList}
              setData={(arr) =>
                setFilterStates((prev) => ({
                  ...prev,
                  status: arr[0] ? arr[0].value : "",
                }))
              }
              data={statusList.filter((v) => v.value === filterStates.status)}
              placeholder="Filter by Status"
              dropdownMainId="status-dropdown"
              withoutMargin
              dropdownMainClass="appointment-filter-height"
              mainDivClass="!w-fit appointment-filter-field-container"
            />
            <SimpleInput
              value={filterStates.startDate}
              onChange={(val) => handleDateChange("startDate", val)}
              type="date"
              placeholder="Start Date"
              withoutMargin
              extraClasses="appointment-filter-height"
              inputContainerClasses="appointment-filter-field-container"
            />
            <SimpleInput
              value={filterStates.endDate}
              onChange={(val) => handleDateChange("endDate", val)}
              type="date"
              placeholder="End Date"
              withoutMargin
              extraClasses="appointment-filter-height"
              inputContainerClasses="appointment-filter-field-container"
            />
            <SearchFilterInput
              key={queryParams.search} // Apply the key here
              onChangeText={(txt: string) =>
                setFilterStates((prev) => ({ ...prev, search: txt }))
              }
              containerExtraStyle={{ display: "block" }}
              extraClasses="appointment-filter-height"
            />
          </div>
          <div className="flex items-center gap-3 justify-end">
            <PrimaryBtn
              disabled={
                !queryParams.status &&
                !queryParams.startDate &&
                !queryParams.endDate &&
                !queryParams.search
              }
              ButtonText="Reset"
              onPress={resetFilter}
              btnExtraStyle={{
                borderRadius: "1.5rem",
                backgroundColor: "#004540",
                padding: "6px 30px",
              }}
            />
            <PrimaryBtn
              ButtonText="Apply"
              onPress={applyFilter}
              btnExtraStyle={{
                borderRadius: "1.5rem",
                backgroundColor: "#004540",
                padding: "6px 30px",
              }}
            />
          </div>
        </div>
        <hr className="products-tabs-hr-allOrder" />
        <TableWrapper
          isLoading={isLoader}
          page={paginated?.currentPage || 1}
          total={paginated?.totalPages || 0}
          thead={[
            "S.No",
            "Customer Name",
            "Service Name",
            "Fee",
            "Date",
            "Time",
            "Status",
            "Action",
          ]}
          onChange={handlePageChange}
          columnWidth="6% 17% 17% 10% 12% 16% 12% 10%"
        >
          <div className="tbody-content-height-appointments-table">
            {allAppointments.map((item, index) => (
              <ul
                key={item._id}
                className={`font-size-16px tbody-light-table font-Poppins-Regular grid  ${
                  !item?.adminNotified ? `font-bold` : ``
                }`}
                style={{
                  gridTemplateColumns: "6% 17% 17% 10% 12% 16% 12% 10%",
                }}
              >
                <li>
                  {(paginated.currentPage - 1) * queryParams.limit +
                    (index + 1)}
                </li>
                <li>{item?.patientName || "-"}</li>
                <li title={item?.serviceName}>
                  {truncateString(item?.serviceName, 40) || "-"}
                </li>
                <li>{CURRENCY} {item?.totalAmount || "-"}</li>
                <li>{moment(item?.appointmentDate).format("DD-MM-YYYY")}</li>
                <li>{item?.timeslot || ""}</li>
                <li style={{ paddingLeft: 0, justifyContent: "center" }}>
                  <span
                    className="py-1 px-4 font-size-13px text-white font-Poppins-SemiBold capitalize rounded"
                    style={{
                      backgroundColor:
                        item.status === "pending"
                          ? statusColor.yellow
                          : item.status === "completed"
                          ? statusColor.green
                          : item.status === "cancelled"
                          ? statusColor.red
                          : "",
                      color:
                        item.status === "pending"
                          ? "#A48E05"
                          : item.status === "completed"
                          ? "#05A100"
                          : item.status === "cancelled"
                          ? "#CF2030"
                          : "",
                    }}
                  >
                    {item?.status}
                  </span>
                </li>
                <li className="action-last-colum justify-center">
                  <Link
                    to={
                      !hasWriteAccess
                        ? "#"
                        : `/admin/homecare-appointment/${item?._id}/view`
                    }
                    id={`view-btn-${index + 1}`}
                  >
                    <FontAwesomeIcon
                      icon={faEye}
                      className={`${!hasWriteAccess ? "read_access" : ""}`}
                    />
                  </Link>
                </li>
              </ul>
            ))}
          </div>
        </TableWrapper>
      </div>
    </>
  );
};

export default HomecareAppointments;
